'use client';

import { usePartners } from '@/data/usePartners';
import PartnerCard from '@/components/PartnerCard/PartnerCard';
import PartnerCardSkeleton from '@/components/PartnerCardSkeleton/PartnerCardSkeleton';
import { getTranslationFor } from '@/text/translations';
import styles from './PartnersGrid.module.css';

export default function PartnersGrid() {
  const { partners, loading, loadingMore, error, loadMore, hasMore } = usePartners();

  if (loading) {
    return (
      <section className={styles.container}>
        <ul className={styles.grid}>
          {Array.from({ length: 5 }).map((_, index) => (
            <PartnerCardSkeleton key={index} />
          ))}
        </ul>
      </section>
    );
  }

  if (error) {
    return (
      <section className={styles.container}>
        <div className={styles.error}>
          <h3>{getTranslationFor('partners.error.title')}</h3>
          <p>{getTranslationFor('partners.error.message')}</p>
        </div>
      </section>
    );
  }

  if (partners.length === 0) {
    return (
      <section className={styles.container}>
        <div className={styles.emptyState}>
          <h3>{getTranslationFor('partners.empty.title')}</h3>
          <p>{getTranslationFor('partners.empty.message')}</p>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.container}>
      <ul className={styles.grid}>
        {partners.map((partner, index) => (
          <PartnerCard
            key={index}
            image={partner.image}
            name={partner.name}
            description={partner.description}
          />
        ))}
        {loadingMore && Array.from({ length: 3 }).map((_, index) => (
          <PartnerCardSkeleton key={`skeleton-${index}`} />
        ))}
      </ul>
      {hasMore && !loadingMore && (
        <button
          className={styles.loadMoreButton}
          onClick={loadMore}
        >
          {getTranslationFor('partners.showMore')}
        </button>
      )}
    </section>
  );
}
